export * from './TestedPartyServiceProvider.proptype';

import { TestedPartyServiceProvider as Component } from './Components/TestedPartyServiceProvider';
import Connector from './connector';

export const TestedPartyServiceProvider = () => <Connector component={Component} />;
